const createLead = () => {};

export default createLead;
